var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canRender && !_vm.isParagraphText)?_c('v-alert',{staticClass:"my-4",attrs:{"text":"","color":_vm.getColorAffichage,"type":_vm.defineType}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.ressource.texte)}})]):(_vm.canRender)?_c('div',{staticClass:"my-4"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.ressource.texte)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }